<script>
  import { createEventDispatcher, onMount } from "svelte";

  export let x = 0;
  export let y = 0;
  export let items = []; // e.g., [{ label: 'Copy', action: 'copy' }]

  const dispatch = createEventDispatcher();
  let menuElement;

  onMount(() => {
    // Auto-adjust position to fit in viewport
    const rect = menuElement.getBoundingClientRect();
    if (x + rect.width > window.innerWidth) {
      x = window.innerWidth - rect.width - 10;
    }
    if (y + rect.height > window.innerHeight) {
      y = window.innerHeight - rect.height - 10;
    }
  });

  function handleClick(action) {
    dispatch("action", action);
    dispatch("close");
  }
</script>

<div
  class="dropdown-menu active"
  style="left: {x}px; top: {y}px;"
  bind:this={menuElement}
>
  {#each items as item}
    {#if item.isSeparator}
      <div
        style="height: 1px; background: var(--glass-border); margin: 4px 0;"
      ></div>
    {:else}
      <button
        class:delete={item.isDelete}
        on:click={() => handleClick(item.action)}
      >
        {item.label}
      </button>
    {/if}
  {/each}
</div>
